import type { CaseStatus } from "./types";

/** UI affordance mirroring the server state machine (server remains the source of truth). */
const NEXT: Record<CaseStatus, CaseStatus[]> = {
  AWAITING_PAYMENT: ["PAYMENT_CONFIRMED", "CANCELLED"],
  PAYMENT_CONFIRMED: ["AWAITING_DOCUMENTS", "READY_FOR_INSPECTION", "CANCELLED"],
  AWAITING_DOCUMENTS: ["DOCUMENTS_UNDER_REVIEW", "CANCELLED"],
  DOCUMENTS_UNDER_REVIEW: ["AWAITING_DOCUMENTS", "READY_FOR_INSPECTION", "CANCELLED"],
  READY_FOR_INSPECTION: ["INSPECTION_SCHEDULED", "INSPECTION_IN_PROGRESS", "CANCELLED"],
  INSPECTION_SCHEDULED: ["INSPECTION_IN_PROGRESS", "READY_FOR_INSPECTION", "CANCELLED"],
  INSPECTION_IN_PROGRESS: ["REPORT_IN_REVIEW", "CANCELLED"],
  REPORT_IN_REVIEW: ["INSPECTION_IN_PROGRESS", "REPORT_READY", "CANCELLED"],
  REPORT_READY: ["COMPLETED", "REPORT_IN_REVIEW", "CANCELLED"],
  COMPLETED: [],
  CANCELLED: [],
};

export function nextTransitions(status: CaseStatus): CaseStatus[] {
  return NEXT[status] ?? [];
}
